import React from 'react';
import styled from 'styled-components';
import GenericButton from '../components/GenericButton';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: #fff;
  border-radius: 8px;
  width: 700px;
  max-width: 95vw;
  max-height: 90vh;
  padding: 2rem 1.5rem 1.5rem 1.5rem;
  box-shadow: 0 4px 32px rgba(0,0,0,0.18);
  overflow-y: auto;
  position: relative;
  font-family: 'Goudy Bookletter 1911', serif;

  @media (max-width: 900px) {
    width: 98vw;
    max-width: 98vw;
    padding: 1.2rem 0.5rem 1rem 0.5rem;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 1.7rem;
  color: #333;
  cursor: pointer;
  z-index: 10;
`;

const Modal = ({ isOpen, onClose, children, showCloseButton = true }) => {
  if (!isOpen) return null;
  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <CloseButton onClick={onClose} aria-label="Kapat">&times;</CloseButton>
        {children}
        {showCloseButton && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 32 }}>
            <GenericButton type="button" onClick={onClose} $fontSize="1.1rem" $maxWidth="220px">
              Kapat
            </GenericButton>
          </div>
        )}
      </ModalContent>
    </ModalOverlay>
  );
};

export default Modal; 